export const taxType = [
    {label: 'VAT 19%' , value: 19},
    {label: 'VAT 7%' , value: 7},
    {label: 'VAT 0%', value: 0}
];